import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    props: true,
    mode:'hash',
    name: 'homeview',
    component: HomeView,
    meta: { title: '郎哥编程课堂'},
  },
  {
    path: '/web',
    mode:'hash',
    name: 'web',
    component: () => import('../views/WebCourse.vue'),
    meta: { title: 'WEB开发课程'},
  },
  {
    path: '/spider',
    mode:'hash',
    name: 'spider',
    component: () => import('../views/SpiderCourse.vue'),
    meta: { title: '爬虫开发课程'},
  },
  {
    path: '/embedded',
    mode:'hash',
    name: 'embedded',
    component: () => import('../views/EmbeddedCourse.vue'),
    meta: { title: '嵌入式开发课程'},
  },
  {
    path: '/intelligence',
    mode:'hash',
    name: 'intelligence',
    component: () => import('../views/IntelligenceCourse.vue'),
    meta: { title: '人工智能开发课程'},
  },
  {
    path: '/mycourse',
    mode:'hash',
    name: 'intelligence',
    component: () => import('../views/MyCourse.vue'),
    meta: { title: '人工智能开发课程'},
  },
  {
    path: '/ShowCourse/:id',
    mode:'hash',
    name: 'ShowCourse',
    component: () => import('../views/ShowCourse.vue'),
    meta: { title: '郎哥编程课堂'},
  },
  {
    path: '/LearnCourse/:id',
    mode:'hash',
    name: 'LearnCourse',
    component: () => import('../views/LearnCourse.vue'),
    meta: { title: '郎哥编程课堂'},
  },
  {
    path: '/ShowExam/:id',
    mode:'hash',
    name: 'ShowExam',
    component: () => import('../views/ShowExam.vue'),
    meta: { title: '课程习题'},
  },
  {
    path: '/ToLogin',
    mode:'hash',
    name: 'Login',
    component: () => import('../views/ToLogin.vue'),
    meta: { title: '郎哥编程课堂'},
  },
  {
    path: '/WxLogin',
    mode:'hash',
    name: 'WxLogin',
    component: () => import('../views/WxLogin.vue'),
    meta: { title: '郎哥编程课堂'},
  },
  {
    path: '/WxLoginProcess',
    mode:'hash',
    props: true,
    name: 'WxLoginProcess',
    component: () => import('../views/WxLoginProcess.vue'),
    meta: { title: '郎哥编程课堂'},
  },
  {
    path: '/ToRegister',
    mode:'hash',
    name: 'ToRegister',
    component: () => import('../views/ToRegister.vue'),
    meta: { title: '郎哥编程课堂'},
  },
  {
    path: '/CourseResource/:id',
    mode:'hash',
    name: 'CourseResource',
    component: () => import('../views/CourseResource.vue'),
    meta: { title: '课程资源'},
  },
  {
    path: '/CourseOrder/:id',
    mode:'hash',
    name: 'CourseOrder',
    component: () => import('../views/CourseOrder.vue'),
    meta: { title: '课程信息'},
  },
  {
    path: '/VerifyOrder/:id',
    mode:'hash',
    name: 'VerifyOrder',
    component: () => import('../views/VerifyOrder.vue'),
    meta: { title: '课程订单'},
  },
  {
    path: '/CourseInfo/:id',
    mode:'hash',
    name: 'CourseInfo',
    component: () => import('../views/CourseInfo.vue'),
    meta: { title: '课程信息'},
  },
  {
    path: '/CourseView/:id',
    mode:'hash',
    name: 'CourseView',
    component: () => import('../views/CourseView.vue'),
    meta: { title: '课程信息'},
  },
  {
    path: '/ExamTest/:id',
    mode:'hash',
    name: 'ExamTest',
    component: () => import('../views/ExamTest.vue'),
    meta: { title: '课程测试'},
  },
  {
    path: '/ExamAnswer/:id',
    mode:'hash',
    name: 'ExamAnswer',
    component: () => import('../views/ExamAnswer.vue'),
    meta: { title: '答题'},
  },
  {
    path: '/ShowArticle/:id',
    mode:'hash',
    name: 'ShowArticle',
    component: () => import('../views/ShowArticle.vue'),
    meta: { title: '文章阅读'},
  },
  {
    path: '/AppShowExamAnswer/:id',
    mode:'hash',
    name: 'AppShowExamAnswer',
    component: () => import('../views/AppShowExamAnswer.vue'),
    meta: { title: '文章阅读'},
  },
  {
    path: '/ShowAnaswer/:id',
    mode:'hash',
    name: 'ShowAnaswer',
    component: () => import('../views/ShowAnaswer.vue'),
    meta: { title: '查看答案'},
  }
]

const router = createRouter({
  //history: createWebHistory(process.env.BASE_URL),
  history:createWebHashHistory(process.env.BASE_URL),  //Hash模式
  routes
})

export default router

